/**
 * Shuffles the elements of an array randomly.
 *
 * @param {Array} array - The array to be shuffled.
 * @returns {Array} A new array with elements shuffled randomly.
 */
export const shuffleArray = array => {
  const data = structuredClone(array)

  for (let i = data.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[data[i], data[j]] = [data[j], data[i]]
  }

  return data
}
